import { CommonModule } from '@angular/common';
import { Component, inject, Inject, Input, OnInit,ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FilterMetadata, MenuItem, MessageService,FilterService,FilterMatchMode, SelectItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { TableLazyLoadEvent, TableModule,Table } from 'primeng/table';

import { firstValueFrom } from 'rxjs';
import { SETTINGS, Settings } from '../../../../app.settings';
import { ProcessingComponent } from '../../../../components';
import { TooltipModule } from 'primeng/tooltip';
import {
  IAppUser,
  InsectaryDashboardService,
  ISearchRequest,
  ISearchSort,
  ISearchRequestFilter,
  ISearchFilterValue,
  OrderStatus
} from '../../../../services/insecta';

import { Breadcrumb } from 'primeng/breadcrumb';
import { notifyAndTrackError } from '../../../../common/error';
import { getItemDescriptionColumn, isNotEmpty, isStringEmpty, toShortDate } from '../../../../common/functions';
import { AppInitService, IInsectaPermissions } from '../../../../services/app-init.service';
import { AppInsightsService } from '../../../../services/app-insights.service';
import { head, template } from 'lodash-es';

@Component({
  selector: 'app-insectary-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    FileUploadModule,
    FormsModule,
    ImageModule,
    InputTextModule,
    TableModule,
    RouterModule,
    ProcessingComponent,
    PaginatorModule,
    InputNumberModule,
    DialogModule,
    Breadcrumb,
    TooltipModule
  ],

  templateUrl: './approve-order.component.html'
})
export class ApproveOrderComponent implements OnInit {
  @Input() appUser!: IAppUser;
  @ViewChild('dt') dt!: Table;
  userSettingsJson: { [key: string]: any } = {};
  route: any;
  permissions!: IInsectaPermissions;
  activeColumnFilters: Set<string> = new Set<string>();
  filtersActive: boolean = false;
  cols: any[] = [];
  customMatchModeOptions: SelectItem[] = [
  { label: 'Starts With', value: FilterMatchMode.STARTS_WITH },
  { label: 'Contains', value: FilterMatchMode.CONTAINS },
  { label: 'Not Contains', value: FilterMatchMode.NOT_CONTAINS },
  { label: 'Ends With', value: FilterMatchMode.ENDS_WITH },
  { label: 'Equals', value: FilterMatchMode.EQUALS },
  { label: 'Not Equals', value: FilterMatchMode.NOT_EQUALS },
  { label: 'Is Empty', value: 'isEmpty' },
  { label: 'Has Value', value: 'isNotEmpty' }
];

dateMatchModeOptions: SelectItem[] = [
  { label: 'Date Is', value: FilterMatchMode.DATE_IS },
  { label: 'Date Is Not', value: FilterMatchMode.DATE_IS_NOT },
  { label: 'Date Before', value: FilterMatchMode.DATE_BEFORE },
  { label: 'Date After', value: FilterMatchMode.DATE_AFTER },
  { label: 'Is Empty', value: 'isEmpty' },
  { label: 'Has Value', value: 'isNotEmpty' }
];

numericMatchModeOptions: SelectItem[] = [
  { label: 'Equals', value: FilterMatchMode.EQUALS },
  { label: 'Not Equals', value: FilterMatchMode.NOT_EQUALS },
  { label: 'Less Than', value: FilterMatchMode.LESS_THAN },
  { label: 'Less Than or Equal', value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
  { label: 'Greater Than', value: FilterMatchMode.GREATER_THAN },
  { label: 'Greater Than or Equal', value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
  { label: 'Is Empty', value: 'isEmpty' },
  { label: 'Has Value', value: 'isNotEmpty' }
];
  pageVars: any = {
    currentUser: ``,
    isEditing: false,
    isReady: false,
    pageId: `Dashboard:InsectaryDashboard:Approve`,
    breadcrumbItems: <MenuItem[]>[]
  };
  columns: string[] = [
    'OrderId',
    'OrderSequence',
    'OrderName',
    'SiteName',
    'RequesterName',
    'OrderItemTypeList',
    'OrderItemTypesValue',
    'ItemDescription',
    'ItemDescription_C',
    'ItemDescription_S',
    'ItemDescription_CS',
    'ProjectList',
    'ProjectValue',
    'FirstDeliveryDate',
    'InsectApprovedCount',
    'SubstrateApprovedCount',
    'InsectSubstrateApprovedCount'
  ];

  orders: any[] = [];

  skip: number = 0;
  take: number = 10;
  totalCount: number = 0;

  insectaryDashboardService: InsectaryDashboardService = inject(InsectaryDashboardService);
  searchRequest: ISearchRequest = {
    columns: [],
    filters: [],
    sorts: [],
    skip: this.skip,
    take: this.take
  };

  itemDescName: string = '';
  siteName: string = '';

  constructor(
    @Inject(SETTINGS) private settings: Settings,
    private msgService: MessageService,
    private appInit: AppInitService,
    private appInsights: AppInsightsService,
    private filterService: FilterService
  ) {
    this.pageVars.pageId = `${settings.environment}:Dashboard:InsectaryDashboard:Approve`;
    appInsights.trackPageView(this.pageVars.pageId, `/dashboard/insectarydashboard/approve`);
  }

  ngOnInit(): void {
    this.pageVars.isReady = false;
    this.permissions = this.appInit.permissions;
    this.filterService.register('isEmpty', (value: any): boolean => {
  return value === undefined || value === null || (typeof value === 'string' && value.trim() === '');
});

  this.filterService.register('isNotEmpty', (value: any): boolean => {
  return value !== undefined && value !== null && (typeof value === 'string' && value.trim() !== ''); 
  });
    this.appUser = this.appInit.appUser;
    if (this.appUser) {
      if (!isStringEmpty(this.appUser.userSettingsJson) || this.appUser.userSettingsJson === '{}') {
        this.userSettingsJson = JSON.parse(this.appUser.userSettingsJson);
      } else {
        this.userSettingsJson = {};
      }

      this.itemDescName = getItemDescriptionColumn(this.userSettingsJson);
      this.siteName = this.userSettingsJson['Default Site'] || '';
    }

    if (this.permissions.canViewInsectaryDashboard && this.permissions.canViewRequestorDashboard) {
      this.pageVars.breadcrumbItems = [{ label: 'Insectary Dashboard', routerLink: '/insectarydashboard' }, { label: 'Approve Orders' }];
    } else {
      this.pageVars.breadcrumbItems = [{ label: 'Dashboard', routerLink: '/insectarydashboard' }, { label: 'Approve Orders' }];
    }

    this.searchRequest.filters = [];
    this.searchRequest.filters.push(<ISearchRequestFilter>{
      fieldname: `SiteName`,
      logic: `and`,
      values: [<ISearchFilterValue>{ operator: `equals`, value: this.siteName }]
    });
    this.searchRequest.filters.push(<ISearchRequestFilter>{
      fieldname: `OrderStatus`,
      logic: `and`,
      values: [<ISearchFilterValue>{ 
        operator: `IN`, 
        value: `${OrderStatus.Submitted},${OrderStatus.InProgress}` 
      }]
    });
    this.initializecolumns();
  }
  initializecolumns() {
    this.cols=[
      {field:'OrderSequence',header:'Order ID',type:'text',template:'link'},
      {field:'OrderName',header:'Order Name',type:'text'},
      {field:'RequesterName',header:'Requester',type:'text'},
      {field:'OrderItemTypesValue',header:'Order Item Types',type:'text'},
      {field:'ProjectValue',header:'Project Value',type:'text',template:'tooltip',style: { 'min-width': '250px' }},
      {field:'FirstDeliveryDate',header:'First Delivery Date',type:'date'},
      {field: 'InsectApprovedCount', header: 'Count of Approved Insect Only Order Item Instances', type: 'numeric' },
      {field: 'SubstrateApprovedCount', header: 'Count of Approved Substrate Order Item Instances', type: 'numeric' },
      {field: 'InsectSubstrateApprovedCount', header: 'Count of Approved Insect+Substrate Order Item Instances', type: 'numeric' }
    ];
    this.syncColumnState()
  }
  private syncColumnState(){
    const stateKey='approve-orders-table';
    try{
      const storedState=localStorage.getItem(stateKey);
      if(!storedState) return;
      const state=JSON.parse(storedState);
      const columnOrder=state?.columnOrder as string[] | undefined;
      if(columnOrder && columnOrder.length !== this.cols.length){
        delete state.columnOrder;
        localStorage.setItem(stateKey,JSON.stringify(state));
      }
    }
    catch(e){
      console.error('Error updating local storage column order',e);
    }
  }
  getColumnHeaderStyle(columnName: string): any {
  return this.activeColumnFilters.has(columnName) ? { 'background-color': '#e0f7fa', 'border-bottom': '2px solid #006064' } : {};
  }
  handleTableEvents(event: TableLazyLoadEvent) {
  this.pageVars.isReady = false;
  this.activeColumnFilters.clear();
  this.searchRequest.filters = [];
  this.searchRequest.filters.push(<ISearchRequestFilter>{
    fieldname: `SiteName`,
    logic: `and`,
    values: [<ISearchFilterValue>{ operator: `equals`, value: this.siteName }]
  });
  this.searchRequest.filters.push(<ISearchRequestFilter>{
    fieldname: `OrderStatus`,
    logic: `and`,
    values: [<ISearchFilterValue>{ 
      operator: `IN`, 
      value: `${OrderStatus.Submitted},${OrderStatus.InProgress}` 
    }]
  });

  this.columns.forEach((columnName) => {
    const columnFilters = event.filters![columnName] as FilterMetadata[];
    if (columnFilters && columnFilters.length > 0) {
      const tableFilter = <ISearchRequestFilter>{
        fieldname: columnName,
        logic: columnFilters[0].operator,
        values: []
      };
    columnFilters.forEach((filterValue) => {
    if (filterValue.matchMode === 'isEmpty' || filterValue.matchMode === 'isNotEmpty') {
    tableFilter.values.push(<ISearchFilterValue>{
      operator: filterValue.matchMode.toUpperCase(),
      value: ''
    });
    } else if (filterValue.value !== null && filterValue.value !== undefined && filterValue.value !== '') {
    tableFilter.values.push(<ISearchFilterValue>{
      operator: filterValue.matchMode || `contains`,
      value: filterValue.matchMode?.startsWith(`date`) ? toShortDate(filterValue.value) : `${filterValue.value}`
    });
  }
});
      
      if (tableFilter.values.length > 0) {
        this.searchRequest.filters.push(tableFilter);
        this.activeColumnFilters.add(columnName);
      }
    }
  });

  this.searchRequest.sorts = [];
  if (isNotEmpty(event.sortField)) {
    this.searchRequest.sorts.push(<ISearchSort>{ name: event.sortField, direction: event.sortOrder === 1 ? 'ASC' : 'DESC' });
  }

  this.searchRequest.skip = event.first;
  this.searchRequest.take = event.rows ?? 10;
  this.filtersActive = this.searchRequest.filters.length > 2 || isNotEmpty(event.sortField);
  this.executeSearch();
}

  executeSearch() {
    const request = this.searchRequest;
    request.columns = [...this.columns, this.itemDescName];

    firstValueFrom(this.insectaryDashboardService.getApprovalTable(request))
      .then(async (response) => {
        this.totalCount = response?.totalCount || 0;
        this.orders = JSON.parse(response?.results ?? `[]`);
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'ApproveOrderComponent', action: 'ExecuteSearch' });
      })
      .finally(() => {
        this.pageVars.isReady = true;
      });
  }
clearFilters(table: Table) {
  table.sortField = null;
  table.sortOrder = 1;

  if (table.filters) {
      Object.keys(table.filters).forEach((key) => {
      const col = this.cols?.find((c: any) => c.field === key);
      const filters = table.filters[key] as any[];
      if (Array.isArray(filters)) {
        filters.forEach((f) => {
          if (f.matchMode === 'isEmpty' || f.matchMode === 'isNotEmpty') {
          if (col?.type === 'date') {
            f.matchMode = 'dateIs';
          } else if (col?.type === 'numeric') {
            f.matchMode = 'equals';
          } else {
            f.matchMode = 'contains';
          }
            f.value = null;
          }
        });
      }
    });
  }

  table.clear();
  this.activeColumnFilters.clear();
  this.filtersActive = false;

  try {
    const stateKey = 'approve-orders-table';
    const storedState = localStorage.getItem(stateKey);
    if (storedState) {
      const state = JSON.parse(storedState);
      delete state.sortField;
      delete state.sortOrder;
      delete state.filters;
      localStorage.setItem(stateKey, JSON.stringify(state));
    }
  } catch (e) {
    console.error('Error updating local storage in clearFilters', e);
  }

  setTimeout(() => {
    this.searchRequest.filters = [];
    this.searchRequest.filters.push(<ISearchRequestFilter>{
      fieldname: `SiteName`,
      logic: `and`,
      values: [<ISearchFilterValue>{ operator: `equals`, value: this.siteName }]
    });
    this.searchRequest.filters.push(<ISearchRequestFilter>{
      fieldname: `OrderStatus`,
      logic: `and`,
      values: [<ISearchFilterValue>{ 
        operator: `IN`, 
        value: `${OrderStatus.Submitted},${OrderStatus.InProgress}` 
      }]
    });
    this.searchRequest.sorts = [];
    this.searchRequest.skip = 0;
    this.searchRequest.take = this.take;
    this.executeSearch();
  }, 100);
}

resetPage(table: Table) {
  table.clear();
  table.clearState();
  window.location.reload();
}
  concatenateOrderItemsTypes(value: any) {
    const arr = JSON.parse(value);
    const itemTypes = arr?.map((item: { ItemType: string }) => item.ItemType) ?? [];
    return itemTypes.join(', ');
  }
  concatenateProjectNames(value: any) {
    const arr = JSON.parse(value);
    const itemTypes = arr?.map((item: { ProjectName: string }) => item.ProjectName) ?? [];
    return itemTypes.join(', ');
  }
}
